export default __webpack_public_path__ + "static/media/one-church.77e7aaf7.png";